$('.product-slider .products_container').slick({
  lazyLoad: 'ondemand',
  slidesToShow: 2,
  slidesToScroll: 2,
  prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>',
  nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>'
});


$('.product-slider-vertical .products_container').slick({
  lazyLoad: 'ondemand',
  slidesToShow: 3,
  slidesToScroll: 3,
  vertical: true,
  prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-up" aria-hidden="true"></i></button>',
  nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-down" aria-hidden="true"></i></button>'
});
